import Ajax from '../js/common/ajax';

export default {
	info: {
		page: (p) => Ajax.post('/declare/info/page', p),
		load: (id) => Ajax.get(`/declare/info/${id}`),
		save: (p) => Ajax.post('/declare/info', p),
		update: (p) => Ajax.put('/declare/info', p),
		delete: (id) => Ajax.delete(`/declare/info/${id}`),
		batchDelete: (ids) => Ajax.post('/declare/info/batchDelete', {ids}),
		oneClickDeclare: (ids) => Ajax.post('/declare/info/oneClickDeclare', {ids})
	},
	account: {
		load: () => Ajax.get('/declare/account'),
		save: (p) => Ajax.post('/declare/account', p)
	},
	taxAccount: {
		list: () => Ajax.get('/declare/taxAccount/list'),
		save: (p) => Ajax.post('/declare/taxAccount', p),
		update: (p) => Ajax.put('/declare/taxAccount', p),
		delete: (id) => Ajax.delete(`/declare/taxAccount/${id}`)
	}
};
